import React, { useState } from 'react';
import { toast } from 'sonner';
import { useApp } from '../context/AppContext';
import { NeighborhoodSelect } from '../components/NeighborhoodSelect';
import { PrimaryButton } from './PhoneFrame';
import { LocationPicker } from '../components/LocationPicker';
import { findNeighborhood } from '../lib/deliveryPricing';

export const AddressEditor = ({ address, onClose }) => {
  const { addresses, saveAddresses, setCheckout, pricingReady, coverage } = useApp();
  const [draft, setDraft] = useState(() => {
    const prefix = address.barrio ? `${address.barrio} - ` : '';
    const detail = address.streetDetail ?? (prefix && address.detail?.startsWith(prefix) ? address.detail.slice(prefix.length) : address.detail || '');
    return { ...address, streetDetail: detail };
  });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!draft.label.trim() || !draft.streetDetail.trim()) return toast.error('Completa la dirección');
    const id = draft.id || `a${Date.now()}`;
    const detail = [draft.barrio, draft.streetDetail.trim()].filter(Boolean).join(' - ');
    const updated = { ...draft, id, label: draft.label.trim(), detail, icon: draft.icon || 'MapPin', default: !!draft.default };
    const list = draft.id ? addresses.map((a) => a.id === id ? updated : a) : [...addresses, updated];
    setBusy(true);
    try { await saveAddresses(list); setCheckout((c) => ({ ...c, addressId: id })); onClose(); toast.success('Dirección guardada'); }
    catch { /* Context displays the error. */ } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3">
      <input data-testid="addr-label" aria-label="Etiqueta" value={draft.label} onChange={(e) => setDraft({ ...draft, label: e.target.value })} placeholder="Etiqueta (Casa, Trabajo...)" className="w-full h-11 px-3 rounded-xl border border-gray-200 text-sm outline-none focus:border-[#EE3B36]" />
      <LocationPicker testId="addr-location" value={draft.location} onChange={(location) => { const zone = location ? findNeighborhood(coverage, { location }) : null; setDraft({ ...draft, location, coverageId: zone?.id || null, barrio: zone?.barrio || '', city: zone?.city || '' }); }} />
      {!draft.location && <NeighborhoodSelect destination={draft} onChange={(zone) => setDraft({ ...draft, ...zone, location: null })} testId="addr-barrio" />}
      <input data-testid="addr-detail" aria-label="Calle y referencia" value={draft.streetDetail} onChange={(e) => setDraft({ ...draft, streetDetail: e.target.value })} placeholder="Calle, casa, punto de referencia" className="w-full h-11 px-3 rounded-xl border border-gray-200 text-sm outline-none focus:border-[#EE3B36]" />
      <PrimaryButton data-testid="addr-save" disabled={busy || !pricingReady} onClick={save}>{busy ? 'Guardando…' : 'Guardar dirección'}</PrimaryButton>
    </div>
  );
};